
import axios from "axios";
import React from "react";
// import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import 'react-toastify/dist/ReactToastify.css'
import { ToastContainer } from "react-toastify";
import Navbar from "./partials/Navbar";
import Footer from "./partials/Footer";
import Login from "./partials/Login";
import RhSidebar from "./partials/rh/Sidebar";
import ComptaSidebar from "./partials/compta/Sidebar";
import StatSidebar from "./partials/stat/Sidebar";
import BiblioSidebar from "./partials/biblio/Sidebar";
import RhRouterPage from "./pages/rh/RouterPage";
import ComptaRouterPage from "./pages/compta/RouterPage";
import StatRouterPage from "./pages/stat/RouterPage";
import BiblioRouterPage from "./pages/biblio/RouterPage";
import Manual from "./pages/manual/Manual";
import EvivesomaAIPanel from "./components/ai/EvivesomaAIPanel";
import { getActiveModule, getModuleUrl, removeLegacyModuleFromUrl, setActiveModule } from "./moduleConfig";

import OfflineStatus from "./components/OfflineStatus";
import ScrollToTop from "./pages/ScrollToTop";
const moduleComponents = {
  rh: { Sidebar: RhSidebar, RouterPage: RhRouterPage },
  compta: { Sidebar: ComptaSidebar, RouterPage: ComptaRouterPage },
  stat: { Sidebar: StatSidebar, RouterPage: StatRouterPage },
  biblio: { Sidebar: BiblioSidebar, RouterPage: BiblioRouterPage }
};

function App() {
  const [isSidebarVisible, setIsSidebarVisible] = React.useState(() => {
    return localStorage.getItem("sidebarVisible") !== "false";
  });
  const [isAIOpen, setIsAIOpen] = React.useState(false);


  const activeModule = getActiveModule();
  setActiveModule(activeModule);
  removeLegacyModuleFromUrl();
  const { Sidebar, RouterPage } = moduleComponents[activeModule];
  const moduleUrl = getModuleUrl(activeModule);
  const token = localStorage.getItem("user")
  var padding = "p-3";
 
  const queryParams = new URLSearchParams(window.location.search);
  const redirect = queryParams.get('redirect');
  if(redirect)
  {
      axios.post('fastlogin', { id : redirect}).then((login) => {
        localStorage.setItem("user", JSON.stringify(login.data.data));
        localStorage.setItem("profiles", JSON.stringify(login.data.profiles));

        if(login.data.profiles.length === 1)
        {
            localStorage.setItem("profile", JSON.stringify(login.data.profiles[0]));
        }
        localStorage.setItem("permissions", login.data.permissions ? JSON.stringify(login.data.permissions) : []);
        window.location.replace(moduleUrl)
    }).catch((error) => {
        window.location.replace(moduleUrl)
    })
  }

  const isLoginPage = window.location.pathname.replace(/\/+$/, "") === "/login";
  const toggleSidebar = () => {
    setIsSidebarVisible((currentValue) => {
      const nextValue = !currentValue;
      localStorage.setItem("sidebarVisible", String(nextValue));
      return nextValue;
    });
  };

  if(!redirect && !token && !isLoginPage)
    return <Login />
  else if(isLoginPage)
    padding = "";

  return (
    <Router>
      <ScrollToTop />
      <div className={
        redirect
          ? "container-fluid d-none"
          : `container-fluid app-shell ${isSidebarVisible ? "" : "app-shell--sidebar-hidden"}`
      }>
            <div className="row flex-nowrap">
              { token && (<Sidebar /> ) }
              <div className="col p-0 m-0 app-main">
              { token && (
                <Navbar
                  isSidebarVisible={isSidebarVisible}
                  onToggleSidebar={toggleSidebar}
                  isAIOpen={isAIOpen}
                  onToggleAI={() => setIsAIOpen((current) => !current)}
                />
              )}
                  
                  <div className={"row col-md-12 app-content " +padding} >
                    <div className=" mb-5 pb-5">
                      <Switch>
                        <Route exact path="/manuel" component={Manual} />
                        <Route component={RouterPage} />
                      </Switch>
                    </div>
                    <ToastContainer />
                    { token && (<Footer />)}
                  </div>
              </div>
            </div>
      </div>
      { token && (<OfflineStatus />)}
      {token && (
        <EvivesomaAIPanel isOpen={isAIOpen} onClose={() => setIsAIOpen(false)} />
      )}
      
    </Router>
  );
}

export default App;
